import { IJsonSerializable } from "../util/interfaces";
import { OpDBScript } from "./op-db-script";
import { OpDBScriptDataSet } from "./op-db-script-data-set";
import { TypeHelper } from "../../helpers/type-helper";

export class OpDBScriptResult implements IJsonSerializable {

    // Members

    public guid: string
    public customScript: OpDBScript
    public isCompleted: boolean
    public executionTime: any
    public error: string
    public data: any

    // Members End

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.guid = opObj.G
                this.isCompleted = opObj.I
                this.executionTime = opObj.E
                this.error = opObj.ER
                if (opObj.C != null) {
                    this.customScript = new OpDBScript(opObj.C)
                }
                if (opObj.D != null) {
                    this.data = new OpDBScriptDataSet(opObj.D)
                }
            } else {
                this.guid = opObj.Guid
                this.isCompleted = opObj.IsCompleted
                this.executionTime = opObj.ExecutionTime
                this.error = opObj.Error
                if (opObj.CustomScript) {
                    this.customScript = new OpDBScript(opObj.CustomScript)
                }
                if (opObj.Data) {
                    this.data = new OpDBScriptDataSet(opObj.Data)
                }
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                G: this.guid,
                C: this.customScript != null ? this.customScript.toJSON(compressed) : null,
                I: this.isCompleted,
                E: this.executionTime,
                ER: this.error,
                D: this.data
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }
            return {
                Guid: this.guid,
                CustonScript: this.customScript != null ? this.customScript.toJSON(compressed) : null,
                IsCompleted: this.isCompleted,
                ExecutionTime: this.executionTime,
                Error: this.error,
                Data: this.data,
            }
        }
        // IJsonSerializable Implementation End
    }

